(function () {
  var STORAGE_KEY = 'rcr_wishlist';

  function getWishlist() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      /* ignore storage errors (e.g. private browsing) */
    }
    window.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: items } }));
  }

  function isInWishlist(id) {
    return getWishlist().some(function (item) {
      return String(item.id) === String(id);
    });
  }

  function escapeHtml(value) {
    var div = document.createElement('div');
    div.textContent = value == null ? '' : value;
    return div.innerHTML;
  }

  class WishlistButton extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.button = this.querySelector('button');
      if (this.button) {
        this.button.addEventListener('click', function (event) {
          event.preventDefault();
          self.toggle();
        });
      }
      this.updateState();
      this._onUpdate = function () {
        self.updateState();
      };
      window.addEventListener('wishlist:updated', this._onUpdate);
    }

    disconnectedCallback() {
      window.removeEventListener('wishlist:updated', this._onUpdate);
    }

    toggle() {
      var items = getWishlist();
      var id = this.dataset.productId;
      var index = -1;
      for (var i = 0; i < items.length; i++) {
        if (String(items[i].id) === String(id)) {
          index = i;
          break;
        }
      }
      if (index > -1) {
        items.splice(index, 1);
      } else {
        items.push({
          id: id,
          handle: this.dataset.productHandle,
          url: this.dataset.productUrl,
          title: this.dataset.productTitle,
          image: this.dataset.productImage,
          price: this.dataset.productPrice,
        });
      }
      setWishlist(items);
    }

    updateState() {
      var active = isInWishlist(this.dataset.productId);
      this.setAttribute('data-active', active ? 'true' : 'false');
      if (this.button) {
        this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
      var saveLabel = this.querySelector('[data-label-save]');
      var savedLabel = this.querySelector('[data-label-saved]');
      if (saveLabel && savedLabel) {
        saveLabel.hidden = active;
        savedLabel.hidden = !active;
      }
    }
  }

  class WishlistCount extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.update();
      this._onUpdate = function () {
        self.update();
      };
      window.addEventListener('wishlist:updated', this._onUpdate);
    }

    disconnectedCallback() {
      window.removeEventListener('wishlist:updated', this._onUpdate);
    }

    update() {
      var count = getWishlist().length;
      this.textContent = count > 0 ? String(count) : '';
      this.hidden = count === 0;
    }
  }

  class WishlistPage extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.render();
      this._onUpdate = function () {
        self.render();
      };
      window.addEventListener('wishlist:updated', this._onUpdate);
    }

    disconnectedCallback() {
      window.removeEventListener('wishlist:updated', this._onUpdate);
    }

    render() {
      var items = getWishlist();
      var grid = this.querySelector('[data-wishlist-grid]');
      var emptyState = this.querySelector('[data-wishlist-empty]');
      if (!grid) return;

      if (items.length === 0) {
        grid.innerHTML = '';
        if (emptyState) emptyState.hidden = false;
        return;
      }

      if (emptyState) emptyState.hidden = true;

      var html = items
        .map(function (item) {
          var image = item.image
            ? '<img src="' +
              escapeHtml(item.image) +
              '" alt="' +
              escapeHtml(item.title) +
              '" loading="lazy" width="400" height="400">'
            : '';
          return (
            '<div class="wishlist-page__item">' +
            '<a href="' +
            escapeHtml(item.url) +
            '" class="wishlist-page__item-link">' +
            '<div class="wishlist-page__item-image">' +
            image +
            '</div>' +
            '<p class="wishlist-page__item-title">' +
            escapeHtml(item.title) +
            '</p>' +
            '<p class="wishlist-page__item-price">' +
            escapeHtml(item.price) +
            '</p>' +
            '</a>' +
            '<button type="button" class="wishlist-page__item-remove" data-remove-id="' +
            escapeHtml(item.id) +
            '">Remove</button>' +
            '</div>'
          );
        })
        .join('');

      grid.innerHTML = html;

      var removeButtons = grid.querySelectorAll('[data-remove-id]');
      for (var i = 0; i < removeButtons.length; i++) {
        removeButtons[i].addEventListener('click', function (event) {
          var id = event.currentTarget.getAttribute('data-remove-id');
          var remaining = getWishlist().filter(function (item) {
            return String(item.id) !== String(id);
          });
          setWishlist(remaining);
        });
      }
    }
  }

  if (!customElements.get('wishlist-button')) {
    customElements.define('wishlist-button', WishlistButton);
  }
  if (!customElements.get('wishlist-count')) {
    customElements.define('wishlist-count', WishlistCount);
  }
  if (!customElements.get('wishlist-page')) {
    customElements.define('wishlist-page', WishlistPage);
  }
})();
